import React from "react";
import "./footer.style.scss";

const Footer = () => {
  return (
    <div className="footer">© 2024 Silkway Marathon. All rights reserved.</div>
  );
};

export default Footer;
